import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// Veri kaynağı (Dosya yolunuzun doğru olduğundan emin olun)
import { iller, ilceler, tumMekanlar } from '../../components/routesData'; 
import {
    TextField, Autocomplete, CircularProgress, Button, Modal, Box, Typography,
    IconButton, Paper
} from '@mui/material';

// Harita Kütüphanesi (Leaflet)
import { MapContainer, TileLayer, Marker, Popup, useMapEvents, Polyline } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Icons
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SaveIcon from '@mui/icons-material/Save'; // İstersen SendIcon ile değiştirebilirsin
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapIcon from '@mui/icons-material/Map';

// --- Leaflet İkon Düzeltmesi ---
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// --- Custom Marker Icons ---
const redIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const greenIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const API_URL = process.env.REACT_APP_API_URL;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#1f2937',
    border: '1px solid #374151',
    boxShadow: 24,
    p: 4,
    borderRadius: '16px',
    color: 'white',
    outline: 'none'
};

const infoModalStyle = {
    ...modalStyle,
    width: 600,
    maxWidth: '90%',
};

const inputStyles = {
    '& .MuiOutlinedInput-root': {
        color: 'white', 
        backgroundColor: '#1f2937',
        '& fieldset': { borderColor: '#4b5563' },
        '&:hover fieldset': { borderColor: '#9ca3af' },
        '&.Mui-focused fieldset': { borderColor: '#2dd4bf' },
    },
    '& .MuiInputLabel-root': { color: '#9ca3af' },
    '& .MuiInputLabel-root.Mui-focused': { color: '#2dd4bf' }
};

// --- Harita Tıklama Bileşeni ---
const LocationSelector = ({ onLocationSelected }) => {
    useMapEvents({
        click(e) {
            onLocationSelected(e.latlng);
        },
    });
    return null;
};

const YeniRotaOlusturSayfasi = () => {
    const navigate = useNavigate();

    // Rota Bilgileri State'leri
    const [rotaAdi, setRotaAdi] = useState('');
    const [rotaAciklamasi, setRotaAciklamasi] = useState('');
    const [ortalamaSure, setOrtalamaSure] = useState('');
    const [nelerOgreneceksinizText, setNelerOgreneceksinizText] = useState('');

    // Görsel Yükleme State'leri
    const [rotaGorseliFile, setRotaGorseliFile] = useState(null);
    const [rotaGorseliPreview, setRotaGorseliPreview] = useState(null);
    const [yuklenenGorselUrl, setYuklenenGorselUrl] = useState('');

    // Mekan Ekleme State'leri
    const [secilenIl, setSecilenIl] = useState('');
    const [secilenIlce, setSecilenIlce] = useState('');
    const [mevcutIlceler, setMevcutIlceler] = useState([]);
    const [arananMekanAdi, setArananMekanAdi] = useState('');
    const [arananMekanBilgi, setArananMekanBilgi] = useState('');
    const [arananMekanLat, setArananMekanLat] = useState('');
    const [arananMekanLon, setArananMekanLon] = useState('');
    const [eklenenMekanlar, setEklenenMekanlar] = useState([]);
    const [filtreliMekanOnerileri, setFiltreliMekanOnerileri] = useState([]);
    const [secilenMekanObj, setSecilenMekanObj] = useState(null);

    // Harita State'i
    const [mapCenter, setMapCenter] = useState([39.9334, 32.8597]); // Default Ankara
    const [mapZoom, setMapZoom] = useState(6);

    // Yükleme ve Hata Durumları
    const [formYukleniyor, setFormYukleniyor] = useState(false);
    
    // Modal State'leri
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({ title: '', message: '' });
    const [isSuccessModal, setIsSuccessModal] = useState(false);
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

    // İl/İlçe değişimi
    useEffect(() => {
        if (secilenIl) {
            setMevcutIlceler(ilceler[secilenIl] || []);
            setSecilenIlce('');
            const selectedIlData = iller.find(i => i.id === secilenIl);
            if(selectedIlData && selectedIlData.lat && selectedIlData.lon) {
                setMapCenter([selectedIlData.lat, selectedIlData.lon]);
                setMapZoom(10);
            }
        } else {
            setMevcutIlceler([]);
            setSecilenIlce('');
        }
    }, [secilenIl]);

    // Görsel Önizleme
    useEffect(() => {
        if (rotaGorseliFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setRotaGorseliPreview(reader.result);
            };
            reader.readAsDataURL(rotaGorseliFile);
        } else {
            setRotaGorseliPreview(null);
        }
    }, [rotaGorseliFile]);

    // Mekan Filtreleme
    useEffect(() => {
        let filtrelenmis = tumMekanlar;
        if (secilenIl) {
            filtrelenmis = filtrelenmis.filter(mekan => mekan.il === iller.find(il => il.id === secilenIl)?.name);
        }
        if (secilenIlce) {
            filtrelenmis = filtrelenmis.filter(mekan => mekan.ilce === mevcutIlceler.find(ilce => ilce.id === secilenIlce)?.name);
        }
        setFiltreliMekanOnerileri(filtrelenmis);
    }, [secilenIl, secilenIlce, mevcutIlceler]);

    // Autocomplete Seçimi
    useEffect(() => {
        if (secilenMekanObj) {
            setArananMekanAdi(secilenMekanObj.ad);
            setArananMekanBilgi(secilenMekanObj.bilgi || secilenMekanObj.aciklama_bolumleri?.[0]?.icerik || '');
            setArananMekanLat(String(secilenMekanObj.latitude || ''));
            setArananMekanLon(String(secilenMekanObj.longitude || ''));
            
            if (secilenMekanObj.latitude && secilenMekanObj.longitude) {
                setMapCenter([secilenMekanObj.latitude, secilenMekanObj.longitude]);
                setMapZoom(15);
            }

            const selectedIlId = iller.find(il => il.name === secilenMekanObj.il)?.id || '';
            setSecilenIl(selectedIlId);

            if (selectedIlId) {
                const correspondingIlces = ilceler[selectedIlId] || [];
                setMevcutIlceler(correspondingIlces);
                const selectedIlceId = correspondingIlces.find(ilce => ilce.name === secilenMekanObj.ilce)?.id || '';
                setSecilenIlce(selectedIlceId);
            }
        }
    }, [secilenMekanObj]);

    // Haritadan seçim yapıldığında
    const handleMapClick = (latlng) => {
        setArananMekanLat(latlng.lat.toFixed(6));
        setArananMekanLon(latlng.lng.toFixed(6));
        if(!arananMekanAdi) {
            setArananMekanAdi(`Seçilen Nokta (${latlng.lat.toFixed(4)}, ${latlng.lng.toFixed(4)})`);
        }
    };

    const openModal = (title, message, isSuccess) => {
        setModalContent({ title, message });
        setIsSuccessModal(isSuccess);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        if (isSuccessModal) {
            navigate('/editor/dashboard'); // Başarılı olursa dashboard'a dön
        }
    };

    const handleMekanEkle = () => {
        const mekanAdi = arananMekanAdi.trim();
        if (mekanAdi === '') {
            openModal("Uyarı", "Lütfen mekan adı girin.", false);
            return;
        }

        const isDuplicate = eklenenMekanlar.some(mekan => mekan.ad.toLowerCase() === mekanAdi.toLowerCase());
        if (isDuplicate) { 
            openModal("Uyarı", "Bu mekan zaten listeye eklenmiş.", false); 
            return; 
        }

        const newMekan = {
            id: Date.now(),
            ad: mekanAdi,
            bilgi: arananMekanBilgi.trim() || 'Ek bilgi yok.',
            il: iller.find(il => il.id === secilenIl)?.name || 'Bilinmiyor',
            ilce: mevcutIlceler.find(ilce => ilce.id === secilenIlce)?.name || 'Bilinmiyor',
            latitude: arananMekanLat ? parseFloat(arananMekanLat) : null,
            longitude: arananMekanLon ? parseFloat(arananMekanLon) : null,
        };
        setEklenenMekanlar([...eklenenMekanlar, newMekan]);

        setArananMekanAdi('');
        setArananMekanBilgi('');
        setArananMekanLat('');
        setArananMekanLon('');
        setSecilenMekanObj(null);
    };

    const handleMekanKaldir = (idToRemove) => {
        setEklenenMekanlar(eklenenMekanlar.filter(mekan => mekan.id !== idToRemove));
    };

    const handleRotayiKaydet = async (e) => {
        e.preventDefault();
        setFormYukleniyor(true);

        const token = localStorage.getItem('token'); 

        if (!token) {
            openModal("Hata", "Oturum bulunamadı. Lütfen tekrar giriş yapın.", false);
            setFormYukleniyor(false);
            navigate('/login');
            return;
        }

        if (!rotaAdi || !rotaAciklamasi || eklenenMekanlar.length === 0) {
            openModal("Hata", "Lütfen rota adı, açıklaması girin ve en az bir mekan ekleyin.", false);
            setFormYukleniyor(false);
            return;
        }

        let finalGorselUrl = '';
        if (rotaGorseliFile) {
            const formData = new FormData();
            formData.append('file', rotaGorseliFile);
            try {
                // Backend endpoint: /editor/upload-image
                const uploadResponse = await axios.post(`${API_URL}/editor/upload-image`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${token}` }
                });
                finalGorselUrl = uploadResponse.data.url;
            } catch (uploadError) {
                openModal("Hata", "Görsel yüklenirken hata oluştu. Lütfen tekrar deneyin.", false);
                setFormYukleniyor(false);
                return;
            }
        }

        // --- GÜNCELLEME: status: false ekliyoruz, is_public'i koruyoruz ---
        const newRotaData = {
            baslik: rotaAdi,
            aciklama: rotaAciklamasi,
            ortalamaSure: ortalamaSure,
            gorsel: finalGorselUrl || yuklenenGorselUrl || null,
            icerdiğiYapılar: eklenenMekanlar.map(mekan => mekan.ad),
            mekanDetaylari: eklenenMekanlar.map(mekan => ({
                ad: mekan.ad,
                bilgi: mekan.bilgi,
                il: mekan.il,
                ilce: mekan.ilce,
                latitude: mekan.latitude,
                longitude: mekan.longitude
            })),
            nelerOgreneceksiniz: nelerOgreneceksinizText.split('\n').filter(i => i.trim()),
            il: eklenenMekanlar[0]?.il,
            ilce: eklenenMekanlar[0]?.ilce,
            is_public: true, // İsteğin üzerine bu alan sabit kaldı
            status: 1 // Yeni onay sistemi için durumu false (beklemede) olarak gönderiyoruz
        };

        try {
            // Backend endpoint: /editor/rotalar
            await axios.post(`${API_URL}/editor/rotalar`, newRotaData, {
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
            });
            // --- Mesaj güncellemesi ---
            openModal("Başarılı", "Rotanız başarıyla oluşturuldu ve yönetici onayına sunuldu. Onaylandıktan sonra yayına alınacaktır.", true);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                openModal("Hata", "Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.", false);
                navigate('/login');
            } else {
                openModal("Hata", 'Rota kaydedilirken bir hata oluştu: ' + (error.response?.data?.detail || error.message), false);
            }
        } finally {
            setFormYukleniyor(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-900 text-white p-4 md:p-8">
            <div className="max-w-7xl mx-auto">
                {/* --- Header --- */}
                <div className="flex justify-between items-center mb-6">
                    <Button onClick={() => navigate('/editor/dashboard')} variant="outlined" startIcon={<ArrowBackIcon />} className="text-gray-400 border-gray-600 hover:bg-gray-800">
                        Vazgeç
                    </Button>
                    <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500">
                        Editör Rota Oluşturucu
                    </h1>
                    <Button onClick={() => setIsInfoModalOpen(true)} startIcon={<HelpOutlineIcon />} className="text-teal-400">
                        Yardım
                    </Button>
                </div>

                <form onSubmit={handleRotayiKaydet} className="space-y-6">
                    {formYukleniyor && (
                         <div className="flex items-center justify-center gap-3 p-4 bg-gray-800 rounded border border-teal-500/30 text-teal-400 animate-pulse">
                            <CircularProgress size={20} className="text-teal-400" />
                            <span>Rota kaydediliyor...</span>
                        </div>
                    )}

                    {/* --- KISIM 1: Genel Bilgiler --- */}
                    <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg">
                        <h2 className="text-xl font-bold text-teal-400 mb-4 flex items-center gap-2">
                            <SaveIcon /> Genel Rota Bilgileri
                        </h2>
                        <div className="grid md:grid-cols-2 gap-6">
                            <div className="space-y-4">
                                <TextField label="Rota Adı" value={rotaAdi} onChange={(e) => setRotaAdi(e.target.value)} fullWidth InputLabelProps={{ shrink: true }} sx={inputStyles} />
                                <TextField label="Ortalama Süre" value={ortalamaSure} onChange={(e) => setOrtalamaSure(e.target.value)} fullWidth InputLabelProps={{ shrink: true }} sx={inputStyles} />
                                <TextField label="Açıklama" value={rotaAciklamasi} onChange={(e) => setRotaAciklamasi(e.target.value)} multiline rows={3} fullWidth InputLabelProps={{ shrink: true }} sx={inputStyles} />
                            </div>
                            <div className="space-y-4">
                                <TextField label="Neler Öğreneceksiniz? (Her satıra bir madde)" value={nelerOgreneceksinizText} onChange={(e) => setNelerOgreneceksinizText(e.target.value)} multiline rows={3} fullWidth InputLabelProps={{ shrink: true }} sx={inputStyles} />
                                <div className="p-4 bg-gray-900 rounded border border-gray-700 flex items-center justify-between">
                                    <div>
                                        <p className="text-sm text-gray-400 mb-2">Kapak Görseli</p>
                                        <Button component="label" variant="contained" size="small" className="bg-gray-700 hover:bg-gray-600">
                                            Dosya Seç
                                            <input type="file" hidden accept="image/*" onChange={(e) => setRotaGorseliFile(e.target.files?.[0])} />
                                        </Button>
                                    </div>
                                    {rotaGorseliPreview && <img src={rotaGorseliPreview} alt="Preview" className="h-16 w-24 object-cover rounded border border-gray-600" />}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* --- KISIM 2: Mekanlar ve Harita --- */}
                    <div className="grid lg:grid-cols-12 gap-6 h-[800px] lg:h-[600px]">
                        
                        {/* Sol Kolon: Form */}
                        <div className="lg:col-span-4 flex flex-col gap-4 h-full">
                            <div className="bg-gray-800 p-4 rounded-xl border border-gray-700 shadow-lg flex-shrink-0">
                                <h2 className="text-lg font-bold text-teal-400 mb-4 flex items-center gap-2">
                                    <LocationOnIcon /> Mekan Ekle
                                </h2>
                                <div className="space-y-3">
                                    <div className="grid grid-cols-2 gap-2">
                                        <select className="bg-gray-900 text-white p-2 rounded border border-gray-600 text-sm" value={secilenIl} onChange={(e) => setSecilenIl(e.target.value)}>
                                            <option value="">İl Seç...</option>
                                            {iller.map(il => <option key={il.id} value={il.id}>{il.name}</option>)}
                                        </select>
                                        <select className="bg-gray-900 text-white p-2 rounded border border-gray-600 text-sm" value={secilenIlce} onChange={(e) => setSecilenIlce(e.target.value)} disabled={!secilenIl}>
                                            <option value="">İlçe Seç...</option>
                                            {mevcutIlceler.map(ilce => <option key={ilce.id} value={ilce.id}>{ilce.name}</option>)}
                                        </select>
                                    </div>
                                    
                                    <Autocomplete
                                        freeSolo
                                        options={filtreliMekanOnerileri}
                                        getOptionLabel={(option) => typeof option === 'string' ? option : (option.ad || '')}
                                        value={secilenMekanObj}
                                        onChange={(e, v) => setSecilenMekanObj(v)}
                                        inputValue={arananMekanAdi}
                                        onInputChange={(e, v) => { setArananMekanAdi(v); if(v !== arananMekanAdi) setSecilenMekanObj(null); }}
                                        renderInput={(params) => <TextField {...params} label="Mekan Adı" size="small" sx={inputStyles} />}
                                        PaperComponent={({children}) => <Paper sx={{bgcolor: '#374151', color: 'white'}}>{children}</Paper>}
                                    />

                                    <div className="grid grid-cols-2 gap-2">
                                        <TextField label="Lat" value={arananMekanLat} size="small" sx={inputStyles} InputProps={{readOnly: true}} placeholder="Haritadan seç" />
                                        <TextField label="Lon" value={arananMekanLon} size="small" sx={inputStyles} InputProps={{readOnly: true}} placeholder="Haritadan seç" />
                                    </div>
                                    <TextField label="Kısa Bilgi" value={arananMekanBilgi} onChange={(e)=>setArananMekanBilgi(e.target.value)} size="small" fullWidth multiline rows={2} sx={inputStyles} />

                                    <Button onClick={handleMekanEkle} fullWidth variant="contained" startIcon={<AddCircleOutlineIcon />} className="bg-teal-600 hover:bg-teal-700">
                                        Listeye Ekle
                                    </Button>
                                </div>
                            </div>

                            {/* Eklenenler Listesi */}
                            <div className="bg-gray-800 p-4 rounded-xl border border-gray-700 shadow-lg flex-grow overflow-auto">
                                <h3 className="text-sm font-semibold text-gray-400 mb-2">Eklenen Mekanlar ({eklenenMekanlar.length})</h3>
                                {eklenenMekanlar.length === 0 ? (
                                    <div className="text-center text-gray-500 text-sm mt-10">Henüz mekan eklenmedi.</div>
                                ) : (
                                    <ul className="space-y-2">
                                        {eklenenMekanlar.map((mekan, i) => (
                                            <li key={mekan.id} className="bg-gray-900 p-2 rounded border border-gray-700 flex justify-between items-center text-sm">
                                                <div className="flex items-center gap-2 overflow-hidden">
                                                    <span className="bg-teal-900 text-teal-400 w-5 h-5 rounded-full flex items-center justify-center text-xs flex-shrink-0">{i+1}</span>
                                                    <span className="truncate">{mekan.ad}</span>
                                                </div>
                                                <IconButton size="small" onClick={() => handleMekanKaldir(mekan.id)} className="text-red-400">
                                                    <DeleteOutlineIcon fontSize="small" />
                                                </IconButton>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>

                        {/* Sağ Kolon: Harita */}
                        <div className="lg:col-span-8 bg-gray-800 p-1 rounded-xl border border-gray-700 shadow-lg h-full relative z-0">
                            <MapContainer center={mapCenter} zoom={mapZoom} style={{ height: '100%', width: '100%', borderRadius: '8px' }}>
                                <TileLayer
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                                />
                                <LocationSelector onLocationSelected={handleMapClick} />
                                {arananMekanLat && arananMekanLon && (
                                    <Marker position={[parseFloat(arananMekanLat), parseFloat(arananMekanLon)]} icon={redIcon}>
                                        <Popup>Şu an seçilen konum: {arananMekanAdi}</Popup>
                                    </Marker>
                                )}
                                {eklenenMekanlar.map((mekan, idx) => (
                                    mekan.latitude && mekan.longitude && (
                                        <Marker key={mekan.id} position={[mekan.latitude, mekan.longitude]} icon={greenIcon}>
                                            <Popup>
                                                <b>{idx + 1}. {mekan.ad}</b><br/>
                                                {mekan.ilce}, {mekan.il}
                                            </Popup>
                                        </Marker>
                                    )
                                ))}
                                {eklenenMekanlar.length > 1 && (
                                    <Polyline 
                                        positions={eklenenMekanlar.filter(m => m.latitude).map(m => [m.latitude, m.longitude])}
                                        color="#2dd4bf"
                                        weight={4}
                                        dashArray="10, 10" 
                                    />
                                )}
                            </MapContainer>
                            <div className="absolute bottom-4 left-4 z-[400] bg-gray-900/80 p-2 rounded text-xs text-white backdrop-blur-sm">
                                <span className="flex items-center gap-1"><span className="w-3 h-3 bg-red-500 rounded-full"></span> Seçili Konum</span>
                                <span className="flex items-center gap-1 mt-1"><span className="w-3 h-3 bg-green-500 rounded-full"></span> Eklenmiş Durak</span>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-end pt-4">
                         {/* Buton Metni Güncellendi */}
                         <Button type="submit" variant="contained" startIcon={<SaveIcon />} className="bg-gradient-to-r from-teal-500 to-indigo-600 py-3 px-8 font-bold text-lg">
                            Rotayı Onaya Gönder
                        </Button>
                    </div>
                </form>

                {/* --- Modals --- */}
                <Modal open={isModalOpen} onClose={handleCloseModal}>
                    <Box sx={modalStyle}>
                        <Typography variant="h6" className={isSuccessModal ? 'text-teal-400' : 'text-red-400'}>{modalContent.title}</Typography>
                        <Typography sx={{ mt: 2 }}>{modalContent.message}</Typography>
                        <Button onClick={handleCloseModal} fullWidth variant="contained" className="mt-4 bg-gray-700">Tamam</Button>
                    </Box>
                </Modal>

                <Modal open={isInfoModalOpen} onClose={() => setIsInfoModalOpen(false)}>
                    <Box sx={infoModalStyle}>
                        <Typography variant="h6" className="text-teal-400 flex gap-2"><MapIcon/> Editör Modu Kullanımı</Typography>
                        <div className="mt-4 space-y-3 text-gray-300 text-sm">
                            <p>1. <strong>Haritadan Seçim:</strong> Harita üzerinde herhangi bir yere tıkladığınızda sol paneldeki Lat/Lon alanları otomatik dolar.</p>
                            <p>2. <strong>Arama:</strong> Sol panelden mekan adı aratıp seçerseniz harita o konuma odaklanır.</p>
                            <p>3. <strong>Rota Sırası:</strong> Eklediğiniz mekanlar haritada yeşil işaretlenir ve aralarında kesikli çizgi ile rota yolu gösterilir.</p>
                        </div>
                    </Box>
                </Modal>
            </div>
        </div>
    );
};

export default YeniRotaOlusturSayfasi;